export default{
    userData: localStorage.getItem('userData')?JSON.parse(localStorage.getItem('userData')):null,
    edit_supplier_info:{},
    merchant_info:localStorage.getItem('merchant_info')?JSON.parse(localStorage.getItem('merchant_info')):null,
}